var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-line-container",style:(_vm.height ? {'height': _vm.height + 'px'} : {})},[_c('canvas',{ref:"chart",style:(_vm.height ? {'height': _vm.height + 'px', 'width': '100%'} : {'width': '100%'})})])}
var staticRenderFns = []

export { render, staticRenderFns }